export function videoLocation(video) {
  return {
    name: "video",
    params: { video_slug: video.slug },
  };
}